module.exports = __webpack_public_path__ + "assets/img/c5c4-nu.svg";